import React from 'react';
import {Route, Switch} from 'react-router-dom';
import {Provider} from 'react-redux';
import compose from 'recompose/compose';
import MainLayout from '../components/main/layout';
import CollectionsPage from '../pages/main/collections';
import FilesPage from '../pages/main/files';
import VideoPage from '../pages/main/file/video';
import PDFPage from '../pages/main/file/pdf';
import NotFound from '../components/not-found/index';
import withFetchLanguages from './with-fetch-languages';
import withWelcomeStart from './with-welcome-start';

import store from '../redux/store';

const MainRoutes = () => (
	<Switch>
		<Route exact path="/" component={CollectionsPage}/>
		<Route exact path="/collections/:collectionId/files" component={FilesPage}/>
		<Route exact path="/collections/:collectionId/video/:fileId" component={VideoPage}/>
		<Route path="*" component={NotFound}/>
	</Switch>
);

const mainEnhance = routes => {
	const EnhancedComponent = withFetchLanguages(routes);

	return props => (
		<Provider store={store}>
			<Switch>
				<Route exact path="/collections/:collectionId/doc/:fileId" component={PDFPage}/>
				<MainLayout {...props}>
					<EnhancedComponent {...props}/>
				</MainLayout>
			</Switch>
		</Provider>
	);
};

const enhance = compose(
	withWelcomeStart,
	mainEnhance
);

export default enhance(MainRoutes);



// WEBPACK FOOTER //
// ./src/client/routes/main.jsx